module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features sr-info gs features-home"
  }, [_c('div', {
    staticClass: "columns column-reverse-mobile"
  }, [_c('div', {
    staticClass: "column column is-one-quarter hide-mobile"
  }, [_c('div', {
    staticClass: "left-sticky"
  }, [_vm._m(0), _c('div', {
    staticClass: "column"
  }, [_c('road-map', {
    attrs: {
      "step": _vm.step,
      "mode": _vm.mode,
      "miningType": _vm.miningType,
      "algorithm": _vm.algorithm,
      "coin": _vm.coin,
      "address": _vm.address,
      "region": _vm.region,
      "port": _vm.port,
      "worker": _vm.worker,
      "referralCode": _vm.referralCode
    },
    on: {
      "jumpToStep": _vm.jumpToStep
    }
  })], 1)])]), _c('div', {
    staticClass: "column is-three-quarter",
    attrs: {
      "id": "step"
    }
  }, [(_vm.step === 0) ? _c('div', [_c('step-mode', {
    on: {
      "selected": _vm.selectMode
    }
  })], 1) : _vm._e(), (_vm.step === 1) ? _c('div', [_c('step-mining-type', {
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectMiningType
    }
  })], 1) : _vm._e(), (_vm.step === 2) ? _c('div', [_c('step-algorithm', {
    attrs: {
      "miningType": _vm.miningType
    },
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectAlgorithm
    }
  })], 1) : _vm._e(), (_vm.step === 3) ? _c('div', [_c('step-coin', {
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectCoin
    }
  })], 1) : _vm._e(), (_vm.step === 4) ? _c('div', [_c('step-address', {
    attrs: {
      "coin": _vm.coin
    },
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectAddress
    }
  })], 1) : _vm._e(), (_vm.step === 5) ? _c('div', [_c('step-region', {
    attrs: {
      "mode": _vm.mode,
      "algorithm": _vm.algorithm
    },
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectRegion
    }
  })], 1) : _vm._e(), (_vm.step === 6) ? _c('div', [_c('step-port', {
    attrs: {
      "mode": _vm.mode,
      "region": _vm.region
    },
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectPort
    }
  })], 1) : _vm._e(), (_vm.step === 7) ? _c('div', [_c('step-worker', {
    attrs: {
      "mode": _vm.mode
    },
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectWorker
    }
  })], 1) : _vm._e(), (_vm.step === 8) ? _c('div', [_c('step-referral', {
    attrs: {
      "mode": _vm.mode
    },
    on: {
      "prev": _vm.prev,
      "selected": _vm.selectReferral
    }
  })], 1) : _vm._e(), (_vm.step === 9) ? _c('div', [_c('step-final', {
    attrs: {
      "mode": _vm.mode,
      "miningType": _vm.miningType,
      "algorithm": _vm.algorithm,
      "coin": _vm.coin,
      "address": _vm.address,
      "region": _vm.region,
      "port": _vm.port,
      "worker": _vm.worker,
      "referralCode": _vm.referralCode
    },
    on: {
      "prev": _vm.prev
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "feature-helvetica top-feature"
  }, [_c('span', [_vm._v(" Our ")]), _c('span', {
    staticClass: "w400"
  }, [_vm._v("Guided Setup")]), _c('span', [_vm._v(" is a tool for using well known third party mining apps with our platform.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-770cfe05","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Wizard.vue
// module id = 385
// module chunks = 1